export const PORTAL_MIGRATION_TOUR_SHOULD_SHOW_KEY = 'brain.portalMigrationTour.shouldShow'

export function stashPortalMigrationTourShouldShow(shouldShow: boolean) {
  try {
    sessionStorage.setItem(PORTAL_MIGRATION_TOUR_SHOULD_SHOW_KEY, shouldShow ? '1' : '0')
  } catch {
    // ignore
  }
}

export function peekStashedPortalMigrationTourShouldShow(): boolean | null {
  try {
    const value = sessionStorage.getItem(PORTAL_MIGRATION_TOUR_SHOULD_SHOW_KEY)
    if (value === null) return null
    return value === '1'
  } catch {
    return null
  }
}

export function clearStashedPortalMigrationTourShouldShow() {
  try {
    sessionStorage.removeItem(PORTAL_MIGRATION_TOUR_SHOULD_SHOW_KEY)
  } catch {
    // ignore
  }
}
